<template>
  <div id="lotacoes">
    <!-- Cabeçalho com botão -->
    <div class="itemTop">
      <label class="form-label">Adicionar Lotações:</label>
      <div class="bt-incluir">
        <button type="button" class="btn-adicionar" @click="adicionarLotacao">
          <span>+</span> Adicionar
        </button>
      </div>
    </div>

    <!-- Lista de lotações -->
    <div
      v-for="(lotacao, i) in lotacoes"
      :key="i"
      class="lotacao-card"
    >
      <div class="lotacao-card-header">
        <h4>Lotação {{ i + 1 }}</h4>
        <button type="button" class="btn-remover" @click="removerLotacao(i)">
          <img
            src="../../assets/imagens/icon-delete-preto.svg"
            alt="Remover"
            title="Remover"
          />
        </button>
      </div>

      <div class="lotacao-card-body">
        <div class="form-group">
          <label>* Unidade:</label>
          <v-select
            v-model="lotacao.unidade"
            :options="unidades"
            label="nomeCompleto"
            placeholder="Selecione a unidade"
            @input="(val) => updateValue(i, 'unidade', val)"
          >
            <template #option="{ nomeCompleto }">
              <div style="white-space: normal; word-break: break-all;">{{ nomeCompleto }}</div>
            </template>
          </v-select>
        </div>
        <div class="form-group">
          <label>* Data de início:</label>
          <input
            type="date"
            v-model="lotacao.dataInicio"
            @input="(e) => updateValue(i, 'dataInicio', e.target.value)"
          />
        </div>
        <div class="form-group">
          <label>Data final:</label>
          <input
            type="date"
            v-model="lotacao.dataFim"
            @input="(e) => updateValue(i, 'dataFim', e.target.value)"
          />
        </div>
        <div class="form-group-radio">
          <label>* Representante?</label>
          <div class="radio-group">
            <label class="radio-label">
              <input
                type="radio"
                :value="true"
                v-model="lotacao.representante"
                @change="() => updateValue(i, 'representante', true)"
              />
              Sim
            </label>
            <label class="radio-label">
              <input
                type="radio"
                :value="false"
                v-model="lotacao.representante"
                @change="() => updateValue(i, 'representante', false)"
              />
              Não
            </label>
          </div>
        </div>
        <div class="form-group" v-if="lotacao.representante && !ehGabinete(lotacao)">
          <label>* Unidade Superior:</label>
          <v-select
            v-model="lotacao.unidadeSuperior"
            :options="filteredUnidades(lotacao)"
            label="nomeCompleto"
            placeholder="Selecione a unidade superior"
            @input="(val) => updateValue(i, 'unidadeSuperior', val)"
          >
            <template #option="{ nomeCompleto }">
              <div style="white-space: normal; word-break: break-all;">{{ nomeCompleto }}</div>
            </template>
          </v-select>
        </div>
        <div class="form-group" v-if="lotacao.representante && ehGabinete(lotacao)">
          <label>Unidade Superior:</label>
          <p class="nota-gabinete">
            Não há Unidade Superior para Gabinete do Secretário.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ServidorApi from "../../services/ServidorApi.js";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "MultiplasLotacoes",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  components: { vSelect },
  data() {
    return {
      unidades: [], // lista vinda da API
      siglaGabinete: "GAB", // unidade máxima: não possui unidade superior
    };
  },
  computed: {
    lotacoes() {
      return this.value || [];
    },
  },
  created() {
    this.servidorApi = new ServidorApi();
    this.carregarUnidades();
  },
  methods: {
    async carregarUnidades() {
      try {
        const dados = await this.servidorApi.getUnidades();

        // 1. Cria a lista formatada com Nome e Sigla
        this.unidades = dados.map(u => ({
          ...u,
          nomeCompleto: u.sigla ? `${u.nome} (${u.sigla})` : u.nome
        }));
        if (this.lotacoes && this.lotacoes.length > 0) {
          const lotacoesAtualizadas = this.lotacoes.map(lotacao => {
            const novaLotacao = { ...lotacao };

            if (novaLotacao.unidade && novaLotacao.unidade.id) {
              const unidadeEncontrada = this.unidades.find(u => u.id === novaLotacao.unidade.id);
              if (unidadeEncontrada) novaLotacao.unidade = unidadeEncontrada;
            }

            if (novaLotacao.unidadeSuperior && novaLotacao.unidadeSuperior.id) {
              const superiorEncontrada = this.unidades.find(u => u.id === novaLotacao.unidadeSuperior.id);
              if (superiorEncontrada) novaLotacao.unidadeSuperior = superiorEncontrada;
            }

            if (this.ehGabinete(novaLotacao)) {
              novaLotacao.unidadeSuperior = null;
            }

            return novaLotacao;
          });

          this.$emit("input", lotacoesAtualizadas);
        }

      } catch (err) {
        console.error("Erro ao carregar unidades", err);
        this.unidades = [];
      }
    },
    adicionarLotacao() {
      if (this.lotacoes.length > 0) {
        const ultimaLotacao = this.lotacoes[this.lotacoes.length - 1];
        if (!ultimaLotacao.dataFim) {
          this.$emit(
            "validation-error",
            "Para adicionar uma nova lotação, a data final da lotação anterior deve ser preenchida."
          );
          return;
        }
      }

      const novaLotacao = {
        id: null,
        unidade: null,
        dataInicio: null,
        dataFim: null,
        representante: false,
        unidadeSuperior: null,
      };
      this.$emit("input", [...this.lotacoes, novaLotacao]);
    },
    removerLotacao(index) {
      this.$emit("clear-validation-error");
      const novasLotacoes = [...this.lotacoes];
      novasLotacoes.splice(index, 1);
      this.$emit("input", novasLotacoes);
    },
    updateValue(index, field, value) {
      if (index === this.lotacoes.length - 1 && field === 'dataFim' && value) {
        this.$emit("clear-validation-error");
      }
      const novasLotacoes = [...this.lotacoes];
      novasLotacoes[index][field] = value;

      if (field === 'representante' && value === false) {
        novasLotacoes[index].unidadeSuperior = null;
      }

      if (field === 'unidade') {
        const unidadeSuperior = novasLotacoes[index].unidadeSuperior;
        if (unidadeSuperior && value && unidadeSuperior.id === value.id) {
          novasLotacoes[index].unidadeSuperior = null;
        }
        if (this.ehGabinete(novasLotacoes[index])) {
          novasLotacoes[index].unidadeSuperior = null;
        }
      }

      this.$emit("input", novasLotacoes);
    },
    ehGabinete(lotacao) {
      return !!(lotacao && lotacao.unidade && lotacao.unidade.sigla === this.siglaGabinete);
    },
    filteredUnidades(lotacao) {
      const siglasPermitidas = ['SGI', 'SLAT', 'GAB'];
      let opcoes = this.unidades.filter(u => siglasPermitidas.includes(u.sigla));
      if (lotacao.unidade) {
        opcoes = opcoes.filter(u => u.id !== lotacao.unidade.id);        
      }      
      return opcoes;
    }
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
#lotacoes {
  width: 100%;
  margin: 0 auto;
  font-family: 'Montserrat', sans-serif;
}

.itemTop {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;

  .form-label {
    font-weight: 600;
    font-size: 1.1rem;
    color: #333;
  }

  .btn-adicionar {
    background-color: #005516;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 0.6rem 1.2rem;
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: #003d10;
    }

    span {
      font-weight: bold;
      margin-right: 0.5rem;
    }
  }
}

.lotacao-card {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 5px rgba(0,0,0,0.05);
  position: relative;
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }
}

.lotacao-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #eee;

  h4 {
    margin: 0;
    color: #005516;
    font-size: 1.2rem;
    font-weight: 600;
  }
}

.lotacao-card-body {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1.5rem;
}

.form-group, .form-group-radio {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  label {
    font-weight: 500;
    font-size: 0.9rem;
    color: #555;
  }
}

.form-group-radio {
  /* justify-content: center; */ // Removed for better alignment
}

input[type="date"],
.v-select {
  width: 100%;
  padding: 0.6rem;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 1rem;
  background-color: #fff;
}

.v-select {
  padding: 0;
}

::v-deep .vs__dropdown-toggle {
  border-radius: 5px;
  border: none;
  padding: 0.3rem;
}

::v-deep .vs__selected {
  white-space: normal;
  word-break: break-all;
}

.nota-gabinete {
  margin: 0;
  font-size: 0.85rem;
  color: #777;
  font-style: italic;
}

.radio-group {
  display: flex;
  gap: 1.5rem;
  align-items: center;
}

.radio-label {
  cursor: pointer;
  font-size: 1rem;
}

.radio-label input[type="radio"] {
  vertical-align: middle;
  margin-right: 0.4rem;
}

.btn-remover {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;

  img {
    height: 1.1rem;
    width: 1.1rem;
    opacity: 0.6;
    transition: opacity 0.3s ease;
  }

  &:hover img {
    opacity: 1;
  }
}
</style>